














































import { Component, Prop, Vue } from 'vue-property-decorator';
import InformationRow from '@/components/display/information-row.vue';
import moment from 'moment';
import { TrialService } from '@/services/trial-service';
import { Product, ProductStatus } from '@/api';

@Component({
	computed: {
		ProductStatus() {
			return ProductStatus;
		},
	},
	components: { InformationRow },
})
export default class TrialRow extends Vue {
	@Prop({ required: true })
	public billingAttributes!: any | null;

	@Prop({ required: true })
	public product!: Product;

	private trialService = new TrialService();

	private get tense(): string {
		return moment.utc(this.billingAttributes.trialStatus.trialEnds.value).diff(moment.now()) > 0
			? 'Ends'
			: 'Ended';
	}
}
